import { ref } from 'vue';

export const emailValid = ref(false);
export const contestAccepted = ref(false);
export const contestGtmFired = ref(false);

export function useContest() {
    return {
        emailValid,
        contestAccepted,
        contestGtmFired,
        reset: () => {
            emailValid.value = false;
            contestAccepted.value = false;
            contestGtmFired.value = false;
        },
    }
}
